import { LoginFormType } from '@/features/reservation/types/LoginFormType';
import { Box, Grid, InputLabel, Stack, TextField, Typography } from '@mui/material';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

export const TextInput = (props: {
  label: string;
  placeholder: string;
  property: keyof Pick<LoginFormType, 'email' | 'password'>; // FIXME: ジェネリクス型にする;
  errors: FieldErrors<LoginFormType>;
  register: UseFormRegister<Pick<LoginFormType, 'email' | 'password'>>; // FIXME: ジェネリクス型にする;
  row?: boolean;
}) => {
  const property = props.property;
  const rowBlocks = props.row || false ? { xs: 6, sm: 12 } : {};
  return (
    <Grid item {...rowBlocks}>
      <Stack direction={'column'} spacing={1}>
        <InputLabel className="font-bold" error={!!props.errors[property]}>
          <Box fontSize={14} ml={0.5}>
            {props.label}
          </Box>
        </InputLabel>
        <TextField
          type="text"
          placeholder={props.placeholder}
          fullWidth
          size="small"
          sx={{ backgroundColor: '#fff', marginTop: '4px !important' }}
          error={!!props.errors[property]}
          {...props.register(property)}
        />
      </Stack>
      <ErrorMessage message={props.errors[property]?.message} />
    </Grid>
  );
};

const ErrorMessage = (props: { message: string | undefined }) => {
  if (!props.message) return;
  return (
    <Typography color="error" style={{ fontSize: '12px', marginLeft: '4px' }}>
      {props.message}
    </Typography>
  );
};
